import {
  NotificationTitleMessage,
  NOTIFICATION_INSERTION,
  NOTIFICATION_TYPE,
  Store,
} from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "animate.css";

type Props = {
  type: NOTIFICATION_TYPE;
  message: NotificationTitleMessage;
  position?: NOTIFICATION_INSERTION;
  duration?: number;
};

export const notify = ({
  type, // success, default, warning, info, danger
  message,
  position,
  duration,
}: Props) => {
  try {
    return Store.addNotification({
      type: type,
      message: message,
      insert: position || "top",
      container: "top-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: duration || 2000,
      },
    });
  } catch (e) {
    console.error(`Notification error : ${e}`);
  }
};

export { ReactNotifications } from "react-notifications-component";

export default notify;
